export default "__VITE_ASSET__T4q7rMqx__"